import React, { useEffect, useState } from 'react';
import AuthUser from '../../services/AuthUser';

const RightSidebarAds = () => {
    const [ads, setAds] = useState([]);
    const [error, setError] = useState('');
         const { http, token } = AuthUser();

    const baseUrl = process.env.REACT_APP_API_URL;

    useEffect(() => {
        http.get('/ads')
            .then(response => {
                if (response.data && response.data.length > 0) {
                    setAds(response.data);
                } else {
                    setError('No ads available.');
                }
            })
            .catch(() => {
                setError('Error loading ads.');
            });
    }, []);

    const renderAd = (ad) => {
        const fileUrl = `${baseUrl}/${ad.filepath}`;
        const ext = ad.filepath.split('.').pop().toLowerCase();

        if (ext === 'mp4' || ext === 'webm') {
            return (
                <video controls style={styles.media}>
                    <source src={fileUrl} type={`video/${ext}`} />
                    Your browser does not support the video tag.
                </video>
            );
        } else if (ext === 'pdf') {
            return (
                <div style={styles.pdfBox} onClick={() => window.open(fileUrl, '_blank')}>
                    View PDF
                </div>
            );
        } else {
            return (
                <img
                    src={fileUrl}
                    alt="Ad"
                    style={styles.media}
                    onClick={() => window.open(fileUrl, '_blank')}
                />
            );
        }
    };

    if (error) return <div className="alert alert-warning">{error}</div>;

    return (
        <div className="row">
            {ads.map((ad, index) => (
                <div className="col-12 mb-4" key={index}>
                    <div className="card shadow-sm border-0 h-100">
                        <div className="card-body p-2 text-center">
                            {renderAd(ad)}
                            <p className="mt-2 mb-0 text-muted" style={{ fontSize: '0.9rem' }}>
                                {ad.caption || 'Sponsored Ad'}
                            </p>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

const styles = {
    media: {
        width: '100%',
        // maxHeight: '204px',
        objectFit: 'cover',
        borderRadius: '8px',
        cursor: 'pointer',
    },
    pdfBox: {
        padding: '10px',
        backgroundColor: '#eee',
        borderRadius: '8px',
        textAlign: 'center',
        fontWeight: 'bold',
        cursor: 'pointer',
    }
};

export default RightSidebarAds;
